import { http } from "@/libs/util.js";
import util from "@/libs/util.js";

const { stock_barcode_validate, query_tax_code, cya_spu_select_search } =
  util.api || {};

// 新增预算申请
export function stockBarcodeValidateApi(params) {
  return http.get(stock_barcode_validate, params);
}

// 新增预算申请
export function getTaxCodeApi(params) {
  return http.get(query_tax_code, params);
}

// 查询SPU下拉 {search: searchKey}
export function getSpuList(params) {
  return http.get(cya_spu_select_search, params);
}
